import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: 'There are no transactions yet',
  description:
    'Once you link transactions to this Contact, they will appear here.',
})
